import { render } from "./AppMain.vue?vue&type=template&id=65457ef0"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=65457ef0&lang=css"
import "./AppMain.vue?vue&type=style&index=1&id=65457ef0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__